import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { ScrollToTop } from '../../../components/common/scroll-to-top/scroll-to-top';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { Posts } from '../../posts/posts';
import { Events } from '../../events/events';
import { Blog } from '../../blog/blog';
import { FavouriteService } from '../../../shared/services/favourites.service';
import { AuthStateService } from '../../../shared/states/auth.state';

type FilterType = 'all' | 'post' | 'blog' | 'event';

interface FavTab {
  label: string;
  type: FilterType;
  icon: string;
}

@Component({
  selector: 'app-favorites',
  standalone: true,
  imports: [CommonModule, ScrollToTop, Posts, Events, Blog],
  templateUrl: './favorites.html',
})
export class Favorites implements OnInit, OnDestroy {
  private authState = inject(AuthStateService);
  private favouriteService = inject(FavouriteService);
  private router = inject(Router);
  private toggleSub?: Subscription;

  activeFilter: FilterType = 'all';

  readonly tabs: FavTab[] = [
    { label: 'All', type: 'all', icon: 'M4 6h16M4 10h16M4 14h16M4 18h16' },
    { label: 'Posts', type: 'post', icon: 'M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10' },
    { label: 'Blogs', type: 'blog', icon: 'M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253' },
    { label: 'Events', type: 'event', icon: 'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z' },
  ];

  get isLoggedIn(): boolean {
    return this.authState.getAuthSnapshot()?.isLoggedIn === true;
  }

  get showPosts(): boolean { return this.activeFilter === 'all' || this.activeFilter === 'post'; }
  get showBlogs(): boolean { return this.activeFilter === 'all' || this.activeFilter === 'blog'; }
  get showEvents(): boolean { return this.activeFilter === 'all' || this.activeFilter === 'event'; }

  ngOnInit(): void {
    if (!this.isLoggedIn) {
      this.router.navigate(['/login']);
    }
  }

  ngOnDestroy(): void {
    this.toggleSub?.unsubscribe();
  }

  setFilter(type: FilterType): void {
    this.activeFilter = type;
  }

  goToLogin(): void {
    this.router.navigate(['/login']);
  }
}
